/**
 * Класс для управления логикой обязательности поля согласия родителей
 * в зависимости от выбранной возрастной категории.
 */
class AgeCategorySelect {
  constructor() {
    /**
     * Элемент select для выбора возрастной категории.
     * @type {HTMLSelectElement|null}
     */
    this.selectElement = document.querySelector('.js-select-age-category');

    /**
     * Поле согласия родителей.
     * @type {HTMLElement|null}
     */
    this.parentalConsentElement = document.querySelector('.js-parental-consent');
    this.parentalConsentElementFeild = this.parentalConsentElement.closest('.js-form-field');

    /**
     * Экземпляр TomSelect плагина
     * @type {TomSelect|null}
     */
    this.tomSelectInstance = null;

    this.init();
  }

  /**
   * Инициализирует компонент, проверяя наличие необходимых элементов
   * и настраивая TomSelect плагин.
   */
  init() {
    if (!this.selectElement) return;

    this.tomSelectInstance = this.selectElement.tomselect;

    if (this.tomSelectInstance) {
      this.attachEvents();
      this.updateFieldState(this.tomSelectInstance.getValue());
    }
  }

  /**
   * Привязывает обработчики событий к экземпляру TomSelect.
   */
  attachEvents() {
    this.tomSelectInstance.on('change', (value) => {
      this.updateFieldState(value);
    });
  }

  /**
   * Обновляет состояние поля согласия родителей в зависимости от выбранной возрастной категории.
   * Если выбрана категория "14-17", поле становится обязательным.
   */
  updateFieldState(ageValue) {
    if (!this.parentalConsentElement) return;

    const isTeenAge = ageValue === '14-17';
    const formField = this.parentalConsentElement.closest('.js-form-field');

    // Управление required атрибутом
    if (isTeenAge) {
      this.parentalConsentElement.setAttribute('required', 'required');
        this.parentalConsentElementFeild.classList.remove('d-none');
    } else {
      this.parentalConsentElement.removeAttribute('required');
      this.parentalConsentElementFeild.classList.add('d-none');
    }
  }
}

new AgeCategorySelect();
